export const ZH_TW = "zh_tw";
export const EN = "en";

export default {
    ZH_TW,
    EN
};